module.exports = __webpack_public_path__ + "static/brocoli-dc0edbe66acca699b3b188778feabb77.jpg";